import React, { createContext, useState } from "react";
import { Paises } from "../../../../repositories/qerpapi/erp/prouser/static/Paises";

import { formatDate } from "../../../../utils/formatDate";
import { Municipios } from "./../../../../repositories/qerpapi/erp/prouser/static/Municipios";
import { Estados } from "./../../../../repositories/qerpapi/erp/prouser/static/Estados";
import { GlobalVariables } from "../../../../GlobalVariables";

const ClienteContext = createContext();

const ClienteContextProvider = ({ children }) => {
  //Dados Gerais
  const [generalCustomerId, setGeneralCustomerId] = useState(null);
  const [generalTypeSubscription, setGeneralTypeSubscription] = useState({
    description: "CPF",
    value: "cpf",
  });
  const [isEmptyCpfCnpj, setIsEmptyCpfCnpj] = useState(true);
  const [generalCpfCnpj, setGeneralCpfCnpj] = useState("");
  const [generalName, setGeneralName] = useState("");
  const [generalFantasy, setGeneralFantasy] = useState("");
  const [generalCep, setGeneralCep] = useState("");
  const [generalAddress, setGeneralAddress] = useState("");
  const [generalNewAddress, setGeneralNewAddress] = useState("");
  const [generalNumber, setGeneralNumber] = useState("");
  const [generalComplement, setGeneralComplement] = useState("");
  const [generalDistrict, setGeneralDistrict] = useState("");
  const [generalUf, setGeneralUf] = useState(null);
  const [generalCounty, setGeneralCounty] = useState(null);
  const [generalNation, setGeneralNation] = useState(
    Paises.find(
      (nation) => nation.codigo === GlobalVariables.countryCodes.brazil
    ) || null
  );
  const [generalTelephone1, setGeneralTelephone1] = useState("");
  const [generalTelephone2, setGeneralTelephone2] = useState("");
  const [generalTelephone3, setGeneralTelephone3] = useState("");
  const [generalEmail, setGeneralEmail] = useState("");
  const [generalRg, setGeneralRg] = useState("");
  const [generalIe, setGeneralIe] = useState("");
  const [generalSimpleNational, setGeneralSimpleNational] = useState(false);
  const [generalFinalCustomer, setGeneralFinalCustomer] = useState(true);
  const [generalIm, setGeneralIm] = useState("");
  const [generalCcm, setGeneralCcm] = useState("");
  const [generalIsuf, setGeneralIsuf] = useState("");
  const [generalCheckBudget, setGeneralCheckBudget] = useState(true);
  const [generalCheckNfe, setGeneralCheckNfe] = useState(true);
  const [generalCheckFinancial, setGeneralCheckFinancial] = useState(true);
  const [generalIeIndication, setGeneralIeIndication] = useState({
    label: "Não Contribuinte",
    value: 0,
    codigo: "9",
  });
  const [generalActive, setGeneralActive] = useState(true);
  const [generalMatriz, setGeneralMatriz] = useState(null);
  const [generalSendEmail, setGeneralSendEmail] = useState(true);
  const [generalDateInitial, setGeneralDateInitial] = useState(
    formatDate({ date: new Date(), separator: "-", format: "yyyy-mm-dd" })
  );
  const [generalWebsite, setGeneralWebsite] = useState("");
  const [generalSendHub, setGeneralSendHub] = useState(false);
  const [ruralProducer, setRuralProducer] = useState(false);
  const [validCpfCnpj, setValidCpfCnpj] = useState(false);

  //Endereços
  const [billingCep, setBillingCep] = useState("");
  const [billingAddress, setBillingAddress] = useState("");
  const [billingNewAddress, setBillingNewAddress] = useState("");
  const [billingNumber, setBillingNumber] = useState("");
  const [billingComplement, setBillingComplement] = useState("");
  const [billingDistrict, setBillingDistrict] = useState("");
  const [billingUf, setBillingUf] = useState(null);
  const [billingCounty, setBillingCounty] = useState(null);
  const [deliveryAddress, setDeliveryAddress] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);

  //Contatos
  const [contacts, setContacts] = useState([]);

  //Autorizados
  const [authorized, setAuthorized] = useState([]);

  //Estabelecimentos Rurais
  const [ruralEstablishment, setRuralEstablishment] = useState([]);

  //Renacionado
  const [mainCustomer, setMainCustomer] = useState([]);
  const [dependentCustomer, setDependentCustomer] = useState([]);
  const [relationship, setRelationship] = useState([]);

  //Info. Comerciais
  const [salesman, setSalesman] = useState(null);
  const [commercialPartner, setCommercialPartner] = useState(null);
  const [defaultPayment, setDefaultPayment] = useState(null);
  const [typePayment, setTypePayment] = useState(null);
  const [tableShipping, setTableShipping] = useState(null);
  const [shippingDiscount, setShippingDiscount] = useState("0,00");
  const [defaultDiscount, setDefaultDiscount] = useState("0,00");
  const [shippingCompany, setShippingCompany] = useState(null);
  const [commercialRegionSelect, setCommercialRegionSelect] = useState("");
  const [irWithheld, setIrWithheld] = useState("0,00");
  const [issWithheld, setIssWithheld] = useState("0,00");
  const [invertDiscount, setInvertDiscount] = useState("0,00");

  //Info. Financeiras
  const [hasRestriction, setHasRestriction] = useState(false);
  const [hasLimit, setHasLimit] = useState(false);
  const [lastSearchSerasa1, setLastSearchSerasa1] = useState("");
  const [lastSearchSerasa2, setLastSearchSerasa2] = useState("");
  const [lastSearchSerasa3, setLastSearchSerasa3] = useState("");
  const [generateCommission, setGenerateCommission] = useState(true);
  const [riskClass, setRiskClass] = useState(null);
  const [limitValue, setLimitValue] = useState("0,00");
  const [financialObservation, setFinancialObservation] = useState("");
  const [billingAlert, setBillingAlert] = useState("");
  const [minimumOrder, setMinimumOrder] = useState("0,00");
  const [bankInformations, setBankInformations] = useState([]);
  const [customerPriceTable, setCustomerPriceTable] = useState([]);
  const [listPriceTable, setListPriceTable] = useState([]);

  //Outras Informações
  const [otherShippingCompany, setOtherShippingCompany] = useState(null);
  const [otherOwnHome, setOtherOwnHome] = useState(null);
  const [otherBirthDate, setOtherBirthDate] = useState("");
  const [otherFathersName, setOtherFathersName] = useState("");
  const [otherRgFather, setOtherRgFather] = useState("");
  const [otherCpfFather, setOtherCpfFather] = useState("");
  const [otherMothersName, setOtherMothersName] = useState("");
  const [otherRgMother, setOtherRgMother] = useState("");
  const [otherCpfMother, setOtherCpfMother] = useState("");
  const [otherAdditionalData, setOtherAdditionalData] = useState("");
  const [otherCompanyName, setOtherCompanyName] = useState("");
  const [otherIssueDate, setOtherIssueDate] = useState("");
  const [otherRemuneration, setOtherRemuneration] = useState("0,00");
  const [otherRole, setOtherRole] = useState("");
  const [otherTelephone, setOtherTelephone] = useState("");
  const [otherCounty, setOtherCounty] = useState(null);
  const [otherAddress, setOtherAddress] = useState("");
  const [otherTypeResidence, setOtherTypeResidence] = useState(null);
  const [otherTimeResidence, setOtherTimeResidence] = useState("");
  const [otherFamilyIncome, setOtherFamilyIncome] = useState("0,00");
  const [otherPersonalReference, setOtherPersonalReference] = useState("");
  const [otherCommercialReference, setOtherCommercialReference] = useState("");
  const [otherNoteNfe, setOtherNoteNfe] = useState("");
  const [otherPartners, setOtherPartners] = useState([]);

  //Dados do Cônjuge
  const [spousesName, setSpousesName] = useState("");
  const [spousesBirthDate, setSpousesBirthDate] = useState("");
  const [spousesTelephone, setSpousesTelephone] = useState("");
  const [spousesRg, setSpousesRg] = useState("");
  const [spousesCpf, setSpousesCpf] = useState("");
  const [spousesCompany, setSpousesCompany] = useState("");
  const [spousesAdmissionDate, setspousesAdmissionDate] = useState("");
  const [spousesRole, setSpousesRole] = useState("");
  const [spousesRemuneration, setSpousesRemuneration] = useState("0,00");
  const [spousesCounty, setSpousesCounty] = useState(null);
  const [spousesAddress, setSpousesAddress] = useState("");

  const [expanded, setExpanded] = useState({ general: true });
  const [listCommercialRegion, setListCommercialRegion] = useState([]);
  const [listRiskClass, setListRiskClass] = useState([]);
  const [listBank, setListBank] = useState([]);
  const [listUf, setListUf] = useState([...Estados]);
  const [listCounty, setListCounty] = useState([...Municipios]);
  const [listNation, setListNation] = useState([...Paises]);
  const [listSalesMan, setListSalesMan] = useState([]);
  const [listCommercialPartner, setListCommercialPartner] = useState([]);
  const [listDefaultPayment, setListDefaultPayment] = useState([]);
  const [listTypePayment, setListTypePayment] = useState([]);
  const [listTableShipping, setListTableShipping] = useState([]);
  const [listShippingCompany, setListShippingCompany] = useState([]);
  const [listCompany, setListCompany] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingInputs, setLoadingInputs] = useState({});
  const [errors, setErrors] = useState({});
  const [showPlugAdd, setShowPlugAdd] = useState(false);

  return (
    <ClienteContext.Provider
      value={{
        //Dados Gerais
        generalCustomerId,
        setGeneralCustomerId,
        generalTypeSubscription,
        setGeneralTypeSubscription,
        isEmptyCpfCnpj,
        setIsEmptyCpfCnpj,
        generalCpfCnpj,
        setGeneralCpfCnpj,
        generalName,
        setGeneralName,
        generalFantasy,
        setGeneralFantasy,
        generalCep,
        setGeneralCep,
        generalAddress,
        setGeneralAddress,
        generalNewAddress,
        setGeneralNewAddress,
        generalNumber,
        setGeneralNumber,
        generalComplement,
        setGeneralComplement,
        generalDistrict,
        setGeneralDistrict,
        generalUf,
        setGeneralUf,
        generalCounty,
        setGeneralCounty,
        generalNation,
        setGeneralNation,
        generalTelephone1,
        setGeneralTelephone1,
        generalTelephone2,
        setGeneralTelephone2,
        generalTelephone3,
        setGeneralTelephone3,
        generalEmail,
        setGeneralEmail,
        generalRg,
        setGeneralRg,
        generalIe,
        setGeneralIe,
        generalSimpleNational,
        setGeneralSimpleNational,
        generalFinalCustomer,
        setGeneralFinalCustomer,
        generalIm,
        setGeneralIm,
        generalCcm,
        setGeneralCcm,
        generalIsuf,
        setGeneralIsuf,
        generalCheckBudget,
        setGeneralCheckBudget,
        generalCheckNfe,
        setGeneralCheckNfe,
        generalCheckFinancial,
        setGeneralCheckFinancial,
        generalActive,
        setGeneralActive,
        generalMatriz,
        setGeneralMatriz,
        generalSendEmail,
        setGeneralSendEmail,
        generalDateInitial,
        setGeneralDateInitial,
        generalIeIndication,
        setGeneralIeIndication,
        generalWebsite,
        setGeneralWebsite,
        generalSendHub,
        setGeneralSendHub,
        ruralProducer,
        setRuralProducer,
        validCpfCnpj,
        setValidCpfCnpj,

        //Endereços
        billingCep,
        setBillingCep,
        billingAddress,
        setBillingAddress,
        billingNewAddress,
        setBillingNewAddress,
        billingNumber,
        setBillingNumber,
        billingComplement,
        setBillingComplement,
        billingCounty,
        setBillingCounty,
        billingUf,
        setBillingUf,
        billingDistrict,
        setBillingDistrict,
        deliveryAddress,
        setDeliveryAddress,
        loadingTable,
        setLoadingTable,

        //Contatos
        contacts,
        setContacts,

        //Autorizados
        authorized,
        setAuthorized,

        //Estabelecimentos Rurais
        ruralEstablishment,
        setRuralEstablishment,

        //Relacionados
        mainCustomer,
        setMainCustomer,
        dependentCustomer,
        setDependentCustomer,
        relationship,
        setRelationship,

        //Info. Comerciais
        salesman,
        setSalesman,
        commercialPartner,
        setCommercialPartner,
        defaultPayment,
        setDefaultPayment,
        typePayment,
        setTypePayment,
        tableShipping,
        setTableShipping,
        shippingDiscount,
        setShippingDiscount,
        defaultDiscount,
        setDefaultDiscount,
        shippingCompany,
        setShippingCompany,
        irWithheld,
        setIrWithheld,
        issWithheld,
        setIssWithheld,
        commercialRegionSelect,
        setCommercialRegionSelect,
        customerPriceTable,
        setCustomerPriceTable,
        listPriceTable,
        setListPriceTable,
        invertDiscount,
        setInvertDiscount,

        //Info. Financeiras
        hasRestriction,
        setHasRestriction,
        hasLimit,
        setHasLimit,
        lastSearchSerasa1,
        setLastSearchSerasa1,
        lastSearchSerasa2,
        setLastSearchSerasa2,
        lastSearchSerasa3,
        setLastSearchSerasa3,
        limitValue,
        setLimitValue,
        generateCommission,
        setGenerateCommission,
        riskClass,
        setRiskClass,
        financialObservation,
        setFinancialObservation,
        billingAlert,
        setBillingAlert,
        minimumOrder,
        setMinimumOrder,
        bankInformations,
        setBankInformations,

        //Outras Informações
        otherShippingCompany,
        setOtherShippingCompany,
        otherOwnHome,
        setOtherOwnHome,
        otherBirthDate,
        setOtherBirthDate,
        otherFathersName,
        setOtherFathersName,
        otherRgFather,
        setOtherRgFather,
        otherCpfFather,
        setOtherCpfFather,
        otherMothersName,
        setOtherMothersName,
        otherRgMother,
        setOtherRgMother,
        otherCpfMother,
        setOtherCpfMother,
        otherAdditionalData,
        setOtherAdditionalData,
        otherCompanyName,
        setOtherCompanyName,
        otherIssueDate,
        setOtherIssueDate,
        otherRemuneration,
        setOtherRemuneration,
        otherRole,
        setOtherRole,
        otherTelephone,
        setOtherTelephone,
        otherCounty,
        setOtherCounty,
        otherAddress,
        setOtherAddress,
        otherTypeResidence,
        setOtherTypeResidence,
        otherTimeResidence,
        setOtherTimeResidence,
        otherFamilyIncome,
        setOtherFamilyIncome,
        otherPersonalReference,
        setOtherPersonalReference,
        otherCommercialReference,
        setOtherCommercialReference,
        otherNoteNfe,
        setOtherNoteNfe,
        otherPartners,
        setOtherPartners,

        //Dados do Cônjuge
        spousesName,
        setSpousesName,
        spousesBirthDate,
        setSpousesBirthDate,
        spousesTelephone,
        setSpousesTelephone,
        spousesRg,
        setSpousesRg,
        spousesCpf,
        setSpousesCpf,
        spousesCompany,
        setSpousesCompany,
        spousesAdmissionDate,
        setspousesAdmissionDate,
        spousesRole,
        setSpousesRole,
        spousesRemuneration,
        setSpousesRemuneration,
        spousesCounty,
        setSpousesCounty,
        spousesAddress,
        setSpousesAddress,

        expanded,
        setExpanded,
        listCommercialRegion,
        setListCommercialRegion,
        listRiskClass,
        setListRiskClass,
        listUf,
        setListUf,
        listBank,
        setListBank,
        listCounty,
        setListCounty,
        listNation,
        setListNation,
        listSalesMan,
        setListSalesMan,
        listCommercialPartner,
        setListCommercialPartner,
        listDefaultPayment,
        setListDefaultPayment,
        listTypePayment,
        setListTypePayment,
        listTableShipping,
        setListTableShipping,
        listShippingCompany,
        setListShippingCompany,
        listCompany,
        setListCompany,
        loading,
        setLoading,
        loadingInputs,
        setLoadingInputs,
        errors,
        setErrors,
        showPlugAdd,
        setShowPlugAdd,
      }}
    >
      {children}
    </ClienteContext.Provider>
  );
};

export { ClienteContextProvider, ClienteContext };
